import React from 'react';
import { cn } from '@/lib/utils';

export interface LoadingSpinnerProps {
  label?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap = {
  sm: 'h-5 w-5',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  label = 'Loading...',
  size = 'md',
  className = '',
}) => {
  return (
    <div className={cn('flex flex-col items-center justify-center', className)} role="status" aria-live="polite">
      <svg
        className={cn(
          'animate-spin',
          sizeMap[size],
          'text-primary-500 dark:text-primary-400 mb-2'
        )}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      {label && (
        <span className="text-gray-600 dark:text-gray-300 text-base font-medium" data-testid="loading-label">
          {label}
        </span>
      )}
    </div>
  );
};

export default LoadingSpinner; 